export const tempSw=()=>{

    return{
        type:"change"
    }
}